import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';
import dayjs from 'dayjs';
import setCustomerBookingCancled from '@/graphql/bookings/setCustomerBookingCancled.gql';

export default {
	state: {
		bookings: [],
		reports: [],
		venue: [],
		pitchesReport: [],
		// pitchOptionsForReport:[],
		CitiesBookingOptions: [],
		CitiesOptionsForReport: [],
		venuOptionsForReport: [],
		playerBookingCancled: [],
		customerBookingCancled: [],
		selectedBookingEditedDate: ''
	},

	// ================ Getters ================
	getters: {
		bookings(state: any) {
			return state.bookings;
		},
		reports(state: any) {
			return state.reports;
		},
		CitiesBookingOptions(state: any) {
			return state.CitiesBookingOptions;
		},
		venue(state: any) {
			return state.venue;
		},
		pitchesReport(state: any) {
			return state.pitchesReport
		},
		CitiesOptionsForReport(state: any) {
			return state.CitiesOptionsForReport;
		},
		venuOptionsForReport(state: any) {
			return state.venuOptionsForReport;
		},
		playerBookingCancled(state: any) {
			return state.playerBookingCancled;
		},
		customerBookingCancled(state: any) {
			return state.customerBookingCancled;
		},
		selectedBookingEditedDate(state: any) {
			return state.selectedBookingEditedDate
		}
	},

	// ================ Mutations ================
	mutations: {
		setBookings(state: any, bookings: any) {
			state.bookings = bookings;
		},
		setReport(state: any, reports: any) {
			state.reports = reports;
		},
		setVenueOptions(state: any, venueData: any) {
			state.venue = venueData;
		},
		setPitchesOption(state: any, pitchData: any) {
			state.pitchesReport = pitchData
		},
		setCitiesOptions(state: any, cityObj: any) {
			state.CitiesBookingOptions = cityObj;
		},
		setCitiesOptionsForReport(state: any, cityObj: any) {
			state.CitiesOptionsForReport = cityObj;
		},
		setVenueOptionsForReport(state: any, venueData: any) {
			state.venuOptionsForReport = venueData;
		},
		setPlayerBookingCancledData(state: any, bookingCancledData: any) {
			state.playerBookingCancled = bookingCancledData;
		},
		setCustomerBookingCancledData(state: any, bookingCancledData: any) {
			state.customerBookingCancled = bookingCancledData;
		},
		setSelectedBookingEditedDate(state: any, bookingEditData: any) {
			state.selectedBookingEditedDate = bookingEditData;
			console.log("state", state.selectedBookingEditedDate)
		},
	},

	// ================= Actions =================
	actions: {
		async getLMBookings({ commit }: any, payload: any) {
			const response2 = await apolloClient.query({
				query: gql`
					query playerbookingCancled {
						player_booking_cancelled {
							booker
							city_id
							country
							created_at
							edited_on
							date
							display_date
							location_id
							payment
							players
							price
							time_from
							time_to
							venu
							pitch_type
							paid
							email
							pitch {
								name
								location {
									name
									currency
									city_id
									city {
										name
										country_id
									}
								}
								type
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const response3 = await apolloClient.query({
				query: gql`
					query customerbookingCancled {
						customer_bookings_cancled {
							booker
							city_id
							country
							created_at
							edited_on
							date
							display_date
							location_id
							payment
							players
							price
							time_from
							time_to
							venu
							is_public
							pitch_type
							deleted_id
							paid
							email
							pitch {
								name
								location {
									name
									currency
									city_id
									city {
										name
										country_id
									}
								}
								type
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const response = await apolloClient.query({
				query: gql`
					query booking {
						player_booking_schedules {
							id
							created_at
							edited_on
							time_from
							time_to
							price
							pitch_type
							pitchId
							pitch_id
							player_booking_id
							split
							location_id
							paid
							payment_holder_name
							payment_id
							pitch {
								type
								name
								location {
									name
									currency
									address
									city {
										id
										name
										country_id
									}
								}
							}
							player_booking {
								player {
									first_name
									last_name
									created_at
									updated_at
									zendesk_id
									email
									cityByCity {
										country {
											name
										}
										name
									}
								}

								payment_type
							}
							display_date
							date
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const response1 = await apolloClient.query({
				query: gql`
					query customerBooking {
						customer_bookings {
							id
							created_at
							edited_on
							created_by
							date
							customer_id
							location_id
							field
							is_public
							customer {
								first_name
								last_name
								created_at
								email
								updated_at
								zendesk_id
							}
							new_player
							time_from
							time_to
							total_price
							payment_method
							paid
							pitch {
								name
								location {
									name
									currency
									city_id
									address
									city {
										name
										country_id
									}
								}
								type
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			let bookings2: any[] = [];
			response1.data.customer_bookings.forEach((ele: any) => {
				if (ele.pitch !== null) {
					bookings2.push({
						editedOn: ele.edited_on ? dayjs(ele.edited_on).format('YYYY/MM/DD HH:mm') : dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						bookedOn: dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						// bookedOn: dayjs(ele.date + " " + ele.time_from).format('YYYY/MM/DD HH:mm'),
						changedOn: ele.customer ? dayjs(ele.customer.updated_at).format('YYYY/MM/DD HH:mm') : '',
						players: ele.customer ? ele.customer.first_name + ' ' + ele.customer.last_name : (ele.new_player ? ele.new_player : ele.created_by),
						// emmail: ele.customer ? ele.customer.email : '',
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,
						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.total_price),
						paid: ele.is_public,
						booker: ele.created_by,
						payment: ele.payment_method === 'stripe' ? 'Credit card' : ele.payment_method,
						city_id: ele.pitch.location.city_id,
						city_name: ele.pitch.location.city.name,
						country: ele.pitch.location.city.country_id,
						currency: ele.pitch.location.currency,
						type: 'customer_booking',
						customer_id: ele.customer_id,
						location_id: ele.location_id,
						split: ele.field,
						pitch_type: ele.pitch.type,
						time_to: ele.time_to,
						time_from: ele.time_from,
						date: ele.date,
						id: ele.id,
						email: ele.customer ? ele.customer.email : '',
						pitch: ele.pitch,
						zendesk_id: ele.customer ? ele.customer.zendesk_id : ''
					});
				}
			});
			console.log('response1', response1);
			let bookings3: any[] = [];
			response.data.player_booking_schedules.forEach((ele: any) => {
				if (ele.pitch !== null) {
					let playerName = '-';
					if (ele.player_booking.player) {
						playerName = ele.player_booking.player.first_name + ' ' + ele.player_booking.player.last_name;
					}
					bookings3.push({
						editedOn: ele.edited_on ? dayjs(ele.edited_on).format('YYYY/MM/DD HH:mm') : dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						bookedOn: dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						// bookedOn:  dayjs(ele.date + " " + ele.time_from).format('YYYY/MM/DD HH:mm'),
						players: playerName,
						payment_id: ele.payment_id ? ele.payment_id : null,
						// emmail: ele.player_booking.email,
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,

						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.price),
						paid: ele.paid !== null ? ele.paid : true,
						booker: ele.payment_holder_name ? ele.payment_holder_name : playerName,
						payment: ele.player_booking.payment_type === 'stripe' ? 'Credit card' : ele.player_booking.payment_type,
						city_id: ele.pitch.location.city.id,
						city_name: ele.pitch.location.city.name,
						country: ele.pitch.location.city.country_id,
						currency: ele.pitch.location.currency,
						type: 'player_booking',
						id: ele.id,
						display_date: ele.display_date,
						location_id: ele.location_id,
						pitchId: ele.pitchId,
						pitch_id: ele.pitch_id,
						split: ele.split,
						date: ele.date,
						pitch_type: ele.pitch_type,
						time_to: ele.time_to,
						time_from: ele.time_from,
						email: ele.player_booking ? (ele.player_booking.player ? ele.player_booking.player.email : '') : '',
						pitch: ele.pitch,
						zendesk_id: ele.player_booking ? (ele.player_booking.player ? ele.player_booking.player.zendesk_id : '') : '',
					});
				}
			});
			let bookings4: any[] = [];
			response2.data.player_booking_cancelled.forEach((ele: any) => {
				if (ele.booker !== null) {
					bookings4.push({
						editedOn: ele.edited_on ? dayjs(ele.edited_on).format('YYYY/MM/DD HH:mm') : dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						bookedOn: dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						// bookedOn: dayjs(ele.date + " " + ele.time_from).format('YYYY/MM/DD HH:mm'),
						players: ele.players,
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,
						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.price),
						paid: ele.paid !== null ? ele.paid : true,
						booker: ele.booker,
						payment: ele.payment === 'stripe' ? 'Credit card' : ele.payment,
						city_id: ele.city_id,
						city_name: ele.pitch.location.city.name,
						country: ele.country,
						currency: ele.pitch.location.currency,
						type: 'player_booking_cancelled',
						display_date: ele.display_date,
						location_id: ele.location_id,
						date: ele.date,
						pitch_type: ele.pitch_type,
						time_to: ele.time_to,
						time_from: ele.time_from,
						email: ele.email,
					});
				}
			});
			console.log('bookings4', bookings4);
			let bookings5: any[] = [];
			response3.data.customer_bookings_cancled.forEach((ele: any) => {
				if (ele.booker !== null) {
					bookings5.push({
						editedOn: ele.edited_on ? dayjs(ele.edited_on).format('YYYY/MM/DD HH:mm') : dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						bookedOn: dayjs(ele.created_at).format('YYYY/MM/DD HH:mm'),
						players: ele.players,
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,
						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.price),
						paid: ele.is_public,
						booker: ele.booker,
						payment: ele.payment === 'stripe' ? 'Credit card' : ele.payment,
						city_id: ele.city_id,
						city_name: ele.pitch.location.city.name,
						country: ele.country,
						currency: ele.pitch.location.currency,
						type: 'Customer_booking_cancelled',
						display_date: ele.display_date,
						location_id: ele.location_id,
						date: ele.date,
						pitch_type: ele.pitch_type,
						time_to: ele.time_to,
						time_from: ele.time_from,
						deleted_id: ele.deleted_id,
						email: ele.email,
					});
				}
			});
			bookings2 = bookings2.filter(obj1 => !bookings5.some(obj2 => obj2.deleted_id == obj1.id));
			let bookings = [...bookings4, ...bookings5, ...bookings2, ...bookings3];
			bookings = [...new Set(bookings)];
			let filterItems: any[] = bookings;
			let cities_obj: { city_id: any; city_name: any; country_id: any }[] = [];
			filterItems.forEach(ele => {
				cities_obj.push({
					city_id: ele.city_id,
					city_name: ele.city_name,
					country_id: ele.country,
				});
			});
			const uniqueCitiesArr = [...new Set(cities_obj.map(obj => JSON.stringify(obj)))].map(str => JSON.parse(str));
			commit('setCitiesOptions', uniqueCitiesArr);
			if (payload) {
				if (payload.players) {
					filterItems = filterItems.filter((ele: any) => ele.players.toLowerCase().includes(payload.players.toLowerCase()));
					// filterItems = filterItems.filter((ele: any) => ele.players.toLowerCase().startsWith(payload.players.toLowerCase()));
				}
				if (payload.country) {
					filterItems = filterItems.filter((ele: any) => ele.country == payload.country);
				}
				if (payload.cities.length !== 0) {
					let citiesFilteredItems: any[] = [];
					let venueOptions: any[] = [];
					let venueCurrencyOptions: any[] = [];

					payload.cities.forEach((city: any, i: number) => {
						citiesFilteredItems.push(...filterItems.filter((ele: any) => ele.city_id == city));
					});
					console.log('citiesFilteredItems', citiesFilteredItems);
					filterItems = citiesFilteredItems;
					filterItems.forEach(ele => {
						venueOptions.push(ele.venue);

						venueCurrencyOptions.push({ venue: ele.venue, currency: ele.currency });
					});
					venueCurrencyOptions = [...new Set(venueCurrencyOptions)];
					console.log('venueCurrencyOptions', venueCurrencyOptions);
					venueOptions = [...new Set(venueOptions)];

					commit('setVenueOptions', venueOptions);
				}
				if (payload.venue.length != 0) {
					let venueFilteredItems: any[] = [];
					payload.venue.forEach((venue: any) => {
						venueFilteredItems.push(...filterItems.filter((ele: any) => ele.venue == venue));
					});
					filterItems = venueFilteredItems;
				}
			} else {
				filterItems = bookings;
			}
			filterItems = filterItems
				.filter(obj => {
					const date = new Date(obj.editedOn);
					return !isNaN(date.getTime());
				})
				.sort((a, b) => {
					const dateA: any = new Date(a.editedOn);
					const dateB: any = new Date(b.editedOn);
					return dateB - dateA;
				});
			filterItems = [...new Set(filterItems)];
			commit('setBookings', filterItems);
			return;
		},
		async getLMReports({ commit }: any, payload: any) {
			const response = await apolloClient.query({
				query: gql`
					query booking {
						player_booking_schedules {
							id
							created_at
							time_from
							time_to
							price
							pitch_type
							pitch {
								type
								name
								location {
									name
									currency
									city {
										id
										name
										country_id
									}
								}
							}
							player_booking {
								player {
									first_name
									last_name
									created_at
									updated_at
									cityByCity {
										country {
											name
										}
										name
									}
								}

								payment_type
							}
							display_date
							date
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const response1 = await apolloClient.query({
				query: gql`
					query customerBooking {
						customer_bookings {
							id
							created_at
							created_by
							date
							customer_id
							location_id
							field
							customer {
								first_name
								last_name
								created_at
								updated_at
							}
							time_from
							time_to
							total_price
							payment_method
							pitch {
								name
								location {
									name
									currency
									city_id
									city {
										name
										country_id
									}
								}
								type
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			let report2: any[] = [];
			response1.data.customer_bookings.forEach((ele: any) => {
				if (ele.pitch !== null) {
					report2.push({
						bookedOn: dayjs(ele.date + ' ' + ele.time_from).format('YYYY/MM/DD HH:mm'),
						changedOn: ele.customer ? dayjs(ele.customer.updated_at).format('YYYY/MM/DD HH:mm') : '',
						players: ele.customer ? ele.customer.first_name + ' ' + ele.customer.last_name : ele.created_by,
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,
						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.total_price),
						paid: ele.paid !== null ? ele.paid : true,
						booker: ele.created_by,
						payment: ele.payment_method === 'stripe' ? 'Credit card' : ele.payment_method,
						city_id: ele.pitch.location.city_id,
						city_name: ele.pitch.location.city.name,
						country: ele.pitch.location.city.country_id,
						currency: ele.pitch.location.currency,
						type: 'customer_booking',
						customer_id: ele.customer_id,
						location_id: ele.location_id,
						split: ele.field,
						pitch_type: ele.pitch.type,
						time_to: ele.time_to,
						time_from: ele.time_from,
						date: ele.date,
						id: ele.id,
					});
				}
			});
			let report3: any[] = [];
			response.data.player_booking_schedules.forEach((ele: any) => {
				if (ele.pitch !== null) {
					let playerName = '-';
					if (ele.player_booking.player) {
						playerName = ele.player_booking.player.first_name + ' ' + ele.player_booking.player.last_name;
					}
					report3.push({
						bookedOn: dayjs(ele.date + ' ' + ele.time_from).format('YYYY/MM/DD HH:mm'),
						players: playerName,
						court: ele.pitch.type + ' Field ' + ele.pitch.name,
						venue: ele.pitch.location.name,
						time_period: ele.date + ' ' + ele.time_from + ' - ' + ele.time_to + " O'Clock",
						price: Number(ele.price),
						paid: true,
						booker: ele.payment_holder_name ? ele.payment_holder_name : playerName,
						payment: ele.player_booking.payment_type === 'stripe' ? 'Credit card' : ele.player_booking.payment_type,
						city_id: ele.pitch.location.city.id,
						city_name: ele.pitch.location.city.name,
						country: ele.pitch.location.city.country_id,
						currency: ele.pitch.location.currency,
						type: 'player_booking',
						id: ele.id,
						display_date: ele.display_date,
						location_id: ele.location_id,
						pitchId: ele.pitchId,
						pitch_id: ele.pitch_id,
						split: ele.split,
						date: ele.date,
						pitch_type: ele.pitch_type,
						time_to: ele.time_to,
						time_from: ele.time_from,
					});
				}
			});
			let report = [...report2, ...report3];
			let filterItems: any[] = report;
			let cities_obj: { city_id: any; city_name: any; country_id: any }[] = [];
			filterItems.forEach(ele => {
				cities_obj.push({
					city_id: ele.city_id,
					city_name: ele.city_name,
					country_id: ele.country,
				});
			});
			const uniqueCitiesArr = [...new Set(cities_obj.map(obj => JSON.stringify(obj)))].map(str => JSON.parse(str));
			commit('setCitiesOptionsForReport', uniqueCitiesArr);
			if (payload) {
				if (payload.players) {
					filterItems = filterItems.filter((ele: any) => ele.players.toLowerCase().startsWith(payload.players.toLowerCase()));
				}
				if (payload.country) {
					filterItems = filterItems.filter((ele: any) => ele.country == payload.country);
				}
				if (payload.cities.length !== 0) {
					let citiesFilteredItems: any[] = [];
					let venueOptions: any[] = [];
					let venueCurrencyOptions: any[] = [];
					let pitchesOption: any[] = [];
					payload.cities.forEach((city: any, i: number) => {
						citiesFilteredItems.push(...filterItems.filter((ele: any) => ele.city_id == city));
					});
					console.log('citiesFilteredItems', citiesFilteredItems);
					filterItems = citiesFilteredItems;
					filterItems.forEach(ele => {
						venueOptions.push(ele.venue);
						pitchesOption.push(ele.pitch_type);
						venueCurrencyOptions.push({ venue: ele.venue, currency: ele.currency });
					});
					venueCurrencyOptions = [...new Set(venueCurrencyOptions)];
					console.log('venueCurrencyOptions', venueCurrencyOptions);
					venueOptions = [...new Set(venueOptions)];
					pitchesOption = [... new Set(pitchesOption)]
					commit('setPitchesOption', pitchesOption)
					commit('setVenueOptionsForReport', venueOptions);
				}
				let venueFilteredItems: any[] = [];
				if (payload.venue.length != 0) {
					payload.venue.forEach((venue: any) => {
						venueFilteredItems.push(...filterItems.filter((ele: any) => ele.venue == venue));
					});
					filterItems = venueFilteredItems;
				}
				let pitchesFilter: any[] = []
				if (payload.pitches.length != 0) {
					payload.pitches.forEach((pitch: any) => {
						pitchesFilter.push(...filterItems.filter((ele: any) => ele.pitch_type == pitch));
					});
					filterItems = pitchesFilter;
				}
				if (payload.date_from && payload.date_to) {
					const startDate = new Date(payload.date_from);
					const endDate = new Date(payload.date_to);
					if (payload.date_from === payload.date_to) {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							console.log(date, startDate, 'startDate');
							return obj.date === payload.date_from;
						});
					} else {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							return date >= startDate && date <= endDate;
						});
					}

					console.log(filterItems, 'filteredArray filteredArray');
				}
			} else {
				filterItems = report;
			}
			filterItems = filterItems
				.filter(obj => {
					const date = new Date(obj.bookedOn);
					return !isNaN(date.getTime());
				})
				.sort((a, b) => {
					const dateA: any = new Date(a.bookedOn);
					const dateB: any = new Date(b.bookedOn);
					return dateB - dateA;
				});
			filterItems = [...new Set(filterItems)];
			commit('setReport', filterItems);
			return;
		},
		async getPlayerBookingCancled({ commit }: any, payload: any) {
			const response = await apolloClient.query({
				query: gql`
					query playerbookingCancled {
						player_booking_cancelled {
							date
							price
							time_from
							time_to
							payment
							email
							pitch {
								location {
									name
									city_id
									city {
										country_id
									}
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			let cancledBookings: any[] = [];
			response.data.player_booking_cancelled.forEach((ele: any) => {
				if (ele.pitch !== null) {
					cancledBookings.push({
						bookedOn: dayjs(ele.date + ' ' + ele.time_from).format('YYYY/MM/DD HH:mm'),
						venue: ele.pitch.location.name,
						price: Number(ele.price),
						city_id: ele.pitch.location.city_id,
						type: 'Player_booking_cancled',
						time_to: ele.time_to,
						time_from: ele.time_from,
						date: ele.date,
						country: ele.pitch.location.city.country_id,
						payment: ele.payment === 'stripe' ? 'Credit card' : ele.payment,
						email: ele.email,
					});
				}
			});
			let filterItems: any[] = cancledBookings;
			if (payload) {
				if (payload.players) {
					filterItems = filterItems.filter((ele: any) => ele.players.toLowerCase().startsWith(payload.players.toLowerCase()));
				}
				if (payload.country) {
					filterItems = filterItems.filter((ele: any) => ele.country == payload.country);
				}
				if (payload.cities.length !== 0) {
					let citiesFilteredItems: any[] = [];
					payload.cities.forEach((city: any, i: number) => {
						citiesFilteredItems.push(...filterItems.filter((ele: any) => ele.city_id == city));
					});
					console.log('citiesFilteredItems', citiesFilteredItems);
					filterItems = citiesFilteredItems;
				}
				if (payload.venue.length != 0) {
					let venueFilteredItems: any[] = [];
					payload.venue.forEach((venue: any) => {
						venueFilteredItems.push(...filterItems.filter((ele: any) => ele.venue == venue));
					});
					console.log('venueFilteredItems', venueFilteredItems);
					filterItems = venueFilteredItems;
				}
				if (payload.date_from && payload.date_to) {
					const startDate = new Date(payload.date_from);
					const endDate = new Date(payload.date_to);
					if (payload.date_from === payload.date_to) {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							console.log(date, startDate, 'startDate');
							return obj.date === payload.date_from;
						});
					} else {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							return date >= startDate && date <= endDate;
						});
					}
				}
			} else {
				filterItems = cancledBookings;
			}
			commit('setPlayerBookingCancledData', filterItems);
			return;
		},
		async getCustomerBookingCancled({ commit }: any, payload: any) {
			const response = await apolloClient.query({
				query: gql`
					query customerbookingCancled {
						customer_bookings_cancled {
							date
							price
							time_from
							time_to
							payment
							email
							pitch {
								location {
									name
									city_id
									city {
										country_id
									}
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			let cancledBookings: any[] = [];
			response.data.customer_bookings_cancled.forEach((ele: any) => {
				if (ele.pitch !== null) {
					cancledBookings.push({
						bookedOn: dayjs(ele.date + ' ' + ele.time_from).format('YYYY/MM/DD HH:mm'),
						venue: ele.pitch.location.name,
						price: Number(ele.price),
						city_id: ele.pitch.location.city_id,
						type: 'customer_booking_cancled',
						time_to: ele.time_to,
						time_from: ele.time_from,
						date: ele.date,
						country: ele.pitch.location.city.country_id,
						payment: ele.payment === 'stripe' ? 'Credit card' : ele.payment,
						email: ele.email,
					});
				}
			});
			let filterItems: any[] = cancledBookings;
			if (payload) {
				if (payload.players) {
					filterItems = filterItems.filter((ele: any) => ele.players.toLowerCase().startsWith(payload.players.toLowerCase()));
				}
				if (payload.country) {
					filterItems = filterItems.filter((ele: any) => ele.country == payload.country);
				}
				if (payload.cities.length !== 0) {
					let citiesFilteredItems: any[] = [];
					payload.cities.forEach((city: any, i: number) => {
						citiesFilteredItems.push(...filterItems.filter((ele: any) => ele.city_id == city));
					});
					console.log('citiesFilteredItems', citiesFilteredItems);
					filterItems = citiesFilteredItems;
				}
				if (payload.venue.length != 0) {
					let venueFilteredItems: any[] = [];
					payload.venue.forEach((venue: any) => {
						venueFilteredItems.push(...filterItems.filter((ele: any) => ele.venue == venue));
					});
					console.log('venueFilteredItems', venueFilteredItems);
					filterItems = venueFilteredItems;
				}
				if (payload.date_from && payload.date_to) {
					const startDate = new Date(payload.date_from);
					const endDate = new Date(payload.date_to);
					if (payload.date_from === payload.date_to) {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							console.log(date, startDate, 'startDate');
							return obj.date === payload.date_from;
						});
					} else {
						filterItems = filterItems.filter(obj => {
							const date = new Date(obj.date);
							return date >= startDate && date <= endDate;
						});
					}
				}
			} else {
				filterItems = cancledBookings;
			}
			commit('setCustomerBookingCancledData', filterItems);
			return;
		},
		async setCustomerBookingCancled(_: any, payload: any) {
			console.log('payload', payload);
			const { data } = await apolloClient.mutate({
				// @ts-ignore
				mutation: setCustomerBookingCancled,
				variables: {
					date: payload.date,
					location_id: payload.location_id,
					customer_booking_id: payload.customer_booking_id,
					display_date: payload.display_date,
					pitch_id: payload.pitch_id,
					price: payload.price,
					pitch_type: payload.pitch_type,
					split: payload.split,
					time_from: payload.time_from,
					time_to: payload.time_to,
					deleted_id: payload.deleted_id,
					created_at: payload.bookedOn,
					players: payload.players,
					booker: payload.booker,
					venu: payload.venu,
					payment: payload.payment,
					city_id: payload.city_id,
					country: payload.country,
					is_public: payload.is_public,
					email: payload.email,
					edited_on: payload.edited_on
				},
			});
			return data;
		},
	},
};
